import { BySport } from '@oneapp/main/core/sport/sport.models';
import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';
import { TaskEngineStatusReport } from '@oneapp/main/core/task-engine/task-engine.models';
import { UserForSportAPI } from '@oneapp/main/core/user/user.models';
import { DateRangeToggleValue, FORM_DEFAULT_VALUE, TaskFiltersFormControlName, TasksFilterValues } from '@oneapp/main/modules/oa-tasks-table-filters/oa-tasks-table-filters.models';

export interface NhlEdgeBackupStateModel {
    tasksBySport: BySport<TaskEngineStatusReport[]>;
    usersForTasksById: { [userSsoId: string]: UserForSportAPI; };
    taskFilters: {
        model: TasksFilterValues;
        dirty?: boolean;
        status?: string;
        errors?: {};
    };
}

export enum NhlEdgeBackupDataCySelector {
    NO_PERMISSION_WARNING = 'nhl-edge-backup-no-permission-warning',
    BACKUP_EDGE_FILES_BUTTON = 'nhl-edge-backup-button'
}

const today = new Date();

const twoDaysAgo = new Date(today);
twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

export const nhlEdgeBackupStateDefaults: StateSliceDefaults<NhlEdgeBackupStateModel> = Object.freeze({
    sliceName: StateSliceName.NHL_EDGE_BACKUP,
    defaults: {
        tasksBySport: {},
        usersForTasksById: {},
        taskFilters: {
            model: {
                [TaskFiltersFormControlName.ENGINE_ID]: undefined,
                [TaskFiltersFormControlName.ENTITY]: FORM_DEFAULT_VALUE,
                [TaskFiltersFormControlName.STATUS]: FORM_DEFAULT_VALUE,
                [TaskFiltersFormControlName.START_DATE]: twoDaysAgo,
                [TaskFiltersFormControlName.END_DATE]: today,
                [TaskFiltersFormControlName.STRING_FILTER]: '',
                [TaskFiltersFormControlName.DATE_PRESET]: DateRangeToggleValue.FORTY_EIGHT,
                [TaskFiltersFormControlName.ONLY_MY_TASKS]: false
            }
        }
    }
});
